module.exports = __webpack_public_path__ + "media/components/outside-promo-page/static/companies-d6ffd1f150cbb35651b51d6e01d1f831.svg";